module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-16.1b55692f.png";